module.exports = __webpack_public_path__ + "static/city-lobzow-3a4be9319be1be68bc375d63ac154552.png";